"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _Header = _interopRequireDefault(require("../../components/Header"));
var _LackingPermissions = _interopRequireDefault(require("../../components/LackingPermissions"));
var _NoProjectsMessage = _interopRequireDefault(require("../../components/NoProjectsMessage"));
var _questPermissionsByArea = _interopRequireDefault(require("../../helpers/questPermissionsByArea.js"));
var _useEnsureDeploymentIds = _interopRequireDefault(require("../../hooks/useEnsureDeploymentIds"));
var _admin = require("../../selectors/admin.js");
var _admin2 = require("../../reducers/admin.js");
var _metricsDataTable = _interopRequireDefault(require("./metricsDataTable.js"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _CustomQueryForm = _interopRequireDefault(require("./CustomQueryForm"));
var _cog = _interopRequireDefault(require("cccisd-icons/cog"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _deepEqual = _interopRequireDefault(require("deep-equal"));
var _style = _interopRequireDefault(require("./style.css"));
var _NewVisualize = _interopRequireDefault(require("./NewVisualize"));
var _QueryNameForm = _interopRequireDefault(require("./QueryNameForm"));
var _showLoader = _interopRequireDefault(require("./showLoader.js"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdReactRouter = require("cccisd-react-router");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd.fortress;
var Boilerplate = window.cccisd.boilerplate;
var Data = function Data(props) {
  var _props$match, _props$match$params;
  var project = props.project,
    assignmentId = props.assignmentId,
    assignmentIdWhitelist = props.assignmentIdWhitelist,
    customSwitchProject = props.customSwitchProject,
    deploymentIdWhitelist = props.deploymentIdWhitelist,
    deploymentIds = props.deploymentIds,
    hideProjectDropdown = props.hideProjectDropdown,
    isExported = props.isExported,
    labelForDeployment = props.labelForDeployment,
    labelForProject = props.labelForProject,
    labelForProjectPlural = props.labelForProjectPlural,
    labelForQuest = props.labelForQuest,
    labelForSurvey = props.labelForSurvey,
    projectIdWhitelist = props.projectIdWhitelist,
    projectQueries = props.projectQueries,
    hasQueryTagFilter = props.hasQueryTagFilter,
    currentQueryId = props.currentQueryId,
    currentQuerySettings = props.currentQuerySettings,
    showCustomizeButton = props.showCustomizeButton,
    showVisualizeButton = props.showVisualizeButton,
    showSaveButton = props.showSaveButton,
    constantFilter = props.constantFilter,
    overrideInitialVisualizeSettings = props.overrideInitialVisualizeSettings,
    overrideVisualizeDeploymentLabels = props.overrideVisualizeDeploymentLabels,
    applyPawnContext = props.applyPawnContext,
    adjustColumns = props.adjustColumns,
    renders = props.renders,
    saveQueryInUrl = props.saveQueryInUrl,
    showVisualizeSettings = props.showVisualizeSettings;
  var queryId = (_props$match = props.match) === null || _props$match === void 0 ? void 0 : (_props$match$params = _props$match.params) === null || _props$match$params === void 0 ? void 0 : _props$match$params.queryId;
  var deployments = props.deployments.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      visualizeLabel: overrideVisualizeDeploymentLabels && overrideVisualizeDeploymentLabels[item.deploymentId] || item.label || ''
    });
  });
  var dispatch = (0, _reactRedux.useDispatch)();
  var tooltipRef = (0, _react.useRef)();
  var history = (0, _cccisdReactRouter.useHistory)();
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    assignmentMetrics = _useState2[0],
    setAssignmentMetrics = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    metricsToVisualize = _useState4[0],
    setMetricsToVisualize = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    tableFilters = _useState6[0],
    setTableFilters = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    tableSelectedRows = _useState8[0],
    setTableSelectedRows = _useState8[1];
  var assignmentSurveys = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentQueryAssignmentSurveys)(state.assignment.admin);
  });
  var restrictionsLevel = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getRestrictionsLevel)(state.assignment.admin);
  });
  var canViewData = Fortress.hasAnyAccess(_questPermissionsByArea["default"].data.permissions, project && project.groupId || 0);
  (0, _useEnsureDeploymentIds["default"])();
  (0, _react.useEffect)(function () {
    // do not save queryId in url if we are using Exported Data component
    if (!saveQueryInUrl) {
      return;
    }
    if (!queryId && currentQueryId !== '0') {
      dispatch((0, _admin2.setCurrentQueryId)('0'));
      return;
    }
    if (!queryId || queryId === currentQueryId) {
      return;
    }
    if (!projectQueries.find(function (query) {
      return query.id === queryId;
    })) {
      history.push("/quest/".concat(project.groupId, "/data"));
      return;
    }
    dispatch((0, _admin2.setCurrentQueryId)(queryId));
  }, [currentQueryId, queryId, projectQueries, saveQueryInUrl]);
  (0, _react.useEffect)(function () {
    var foundQuery = projectQueries.find(function (query) {
      return query.id === currentQueryId;
    });
    if (!foundQuery && hasQueryTagFilter && projectQueries.length > 0) {
      dispatch((0, _admin2.setCurrentQueryId)(projectQueries[0].id));
    }
  }, [currentQueryId, projectQueries, hasQueryTagFilter]);
  var loadAssignmentMetrics = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id) {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (!assignmentMetrics[id]) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            (0, _showLoader["default"])(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
              var response, metrics;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    _context.n = 1;
                    return _cccisdAxios["default"].get(Boilerplate.route('api.assignment.metrics.customVariableList', {
                      assignmentId: id
                    }));
                  case 1:
                    response = _context.v;
                    // we need deduplicate list as we could have the same reportHeader for different languages
                    metrics = (0, _uniqBy2["default"])(response.data.data.metrics.variableList, 'reportHeader').map(function (item) {
                      var _item$key;
                      return {
                        reportHeader: item.reportHeader,
                        surveyHandles: item.surveyHandles,
                        type: item.type,
                        label: item.label,
                        question: item.key.title,
                        questionType: item.key.questionType,
                        isIdentifying: Boolean(item === null || item === void 0 ? void 0 : (_item$key = item.key) === null || _item$key === void 0 ? void 0 : _item$key.isIdentifying),
                        isFile: item.tagList.some(function (obj) {
                          return obj.scope === 'system' && obj.handle === 'fileUpload';
                        })
                      };
                    });
                    setAssignmentMetrics(function (prev) {
                      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, id, metrics));
                    });
                  case 2:
                    return _context.a(2);
                }
              }, _callee);
            })));
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function loadAssignmentMetrics(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    loadAssignmentMetrics(currentQuerySettings.assignmentId);
  }, [currentQuerySettings.assignmentId]);
  var hasChanges = (0, _react.useMemo)(function () {
    if (!currentQueryId || currentQueryId === '0') {
      return false;
    }
    var foundQuery = projectQueries.find(function (query) {
      return query.id === currentQueryId;
    });
    return foundQuery ? !(0, _deepEqual["default"])(
    // vizualize will handle its own equality check
    (0, _omit2["default"])(foundQuery.settings, ['visualizationSettings']), (0, _omit2["default"])(currentQuerySettings, ['visualizationSettings'])) : true;
  }, [currentQuerySettings, currentQueryId, projectQueries]);
  var syncTableProps = function syncTableProps(_ref3) {
    var filters = _ref3.filters,
      selectedRows = _ref3.selectedRows;
    var filterValues = Object.values(filters).filter(function (f) {
      return f.props.value;
    }).map(function (f) {
      return {
        contains: {
          field: f.props.column,
          string: f.props.value
        }
      };
    });
    if (constantFilter) {
      filterValues.push(constantFilter);
    }
    if (!tableFilters || !(0, _isEqual2["default"])(filterValues, tableFilters)) {
      setTableFilters(filterValues);
    }
    if (!(0, _isEqual2["default"])(selectedRows, tableSelectedRows)) {
      setTableSelectedRows(selectedRows);
    }
  };
  if (!canViewData) {
    return /*#__PURE__*/_react["default"].createElement(_LackingPermissions["default"], {
      customSwitchProject: customSwitchProject,
      hideProjectDropdown: hideProjectDropdown,
      isExported: isExported,
      labelForProject: labelForProject,
      labelForProjectPlural: labelForProjectPlural,
      limitProjectsByPermissions: _questPermissionsByArea["default"].data.permissions,
      projectIdWhitelist: projectIdWhitelist
    });
  }
  var currentAssignmentMetrics = assignmentMetrics[currentQuerySettings.assignmentId];
  var queryDropdown = showSaveButton || projectQueries.length >= 2 ? /*#__PURE__*/_react["default"].createElement("select", {
    className: "form-select",
    name: "query",
    style: {
      maxWidth: '200px'
    },
    onChange: function onChange(e) {
      if (saveQueryInUrl) {
        history.push(e.target.value === '0' ? "/quest/".concat(project.groupId, "/data") : "/quest/".concat(project.groupId, "/data/").concat(e.target.value));
      } else {
        dispatch((0, _admin2.setCurrentQueryId)(e.target.value));
      }
    },
    value: currentQueryId
  }, !hasQueryTagFilter && /*#__PURE__*/_react["default"].createElement("option", {
    value: "0"
  }, "Default"), projectQueries.map(function (query) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      value: query.id,
      key: query.id
    }, query.name);
  })) : null;
  var customizeButton = showCustomizeButton ? /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    title: "Customize query",
    size: "large",
    renderTrigger: function renderTrigger(_ref4) {
      var onClick = _ref4.onClick;
      return renders.renderCustomizeButton ? renders.renderCustomizeButton({
        open: onClick
      }) : /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-secondary",
        style: {
          marginLeft: '1rem'
        },
        onClick: onClick
      }, /*#__PURE__*/_react["default"].createElement(_cog["default"], {
        spaceRight: true
      }), "Customize");
    },
    render: function render(_ref5) {
      var closeModal = _ref5.closeModal;
      return /*#__PURE__*/_react["default"].createElement(_CustomQueryForm["default"], {
        assignmentMetrics: assignmentMetrics,
        loadAssignmentMetrics: loadAssignmentMetrics,
        initialValues: currentQuerySettings,
        onSubmit: function onSubmit(values) {
          return dispatch((0, _admin2.setCurrentQuerySettings)(values));
        },
        onDelete: showSaveButton && currentQueryId && currentQueryId !== '0' ? function () {
          closeModal();
          dispatch((0, _admin2.deleteCurrentQuery)());
        } : null,
        closeModal: closeModal
      });
    }
  }) : null;
  var visualizeButton = showVisualizeButton ? /*#__PURE__*/_react["default"].createElement(_NewVisualize["default"], {
    metrics: metricsToVisualize,
    deploymentIds: deploymentIds,
    deployments: deployments,
    tableFilters: tableFilters,
    tableSelectedRows: tableSelectedRows,
    currentQueryId: currentQueryId,
    currentQuerySettings: currentQuerySettings,
    SaveQueryButton: SaveQueryButton,
    overrideInitialVisualizeSettings: overrideInitialVisualizeSettings,
    applyPawnContext: applyPawnContext,
    renderVisualizeButton: renders.renderVisualizeButton,
    renderSaveQueryButton: function renderSaveQueryButton(buttonProps) {
      return /*#__PURE__*/_react["default"].createElement(SaveQueryButton, _extends({
        showSaveButton: showSaveButton,
        project: project,
        currentQueryId: currentQueryId,
        tooltipRef: tooltipRef,
        dispatch: dispatch,
        currentQuerySettings: currentQuerySettings,
        hasChanges: hasChanges
      }, buttonProps));
    },
    showSettings: showVisualizeSettings
  }) : null;
  var saveButton = /*#__PURE__*/_react["default"].createElement(SaveQueryButton, {
    showSaveButton: showSaveButton,
    project: project,
    currentQueryId: currentQueryId,
    tooltipRef: tooltipRef,
    dispatch: dispatch,
    currentQuerySettings: currentQuerySettings,
    hasChanges: hasChanges
  });
  var getRightSection = function getRightSection() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].customize
    }, queryDropdown && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label"
    }, "Query"), queryDropdown), customizeButton, restrictionsLevel !== 'basic' && visualizeButton, saveButton);
  };
  var showHeader = !hideProjectDropdown || showCustomizeButton || showSaveButton || showVisualizeButton || projectQueries.length > 1;
  if (projectQueries.length === 0 && hasQueryTagFilter) {
    return /*#__PURE__*/_react["default"].createElement("h3", {
      className: _style["default"].info
    }, "There are no queries to show");
  }
  var table = function () {
    if (!assignmentId) {
      return /*#__PURE__*/_react["default"].createElement(_NoProjectsMessage["default"], {
        isExported: isExported
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, deploymentIds.length > 0 && currentAssignmentMetrics ? /*#__PURE__*/_react["default"].createElement(_metricsDataTable["default"], {
      metrics: currentAssignmentMetrics,
      deploymentIds: deploymentIds,
      syncTableProps: syncTableProps,
      constantFilter: constantFilter,
      setMetricsToVisualize: setMetricsToVisualize,
      showCustomizeButton: showCustomizeButton,
      applyPawnContext: applyPawnContext,
      adjustColumns: adjustColumns
    }) : null, assignmentSurveys.length === 0 && /*#__PURE__*/_react["default"].createElement("h3", {
      className: _style["default"].info
    }, "This ", labelForQuest || 'Quest', " does not have any ", labelForSurvey || 'survey', "s"), assignmentSurveys.length !== 0 && deploymentIds.length === 0 && /*#__PURE__*/_react["default"].createElement("h3", {
      className: _style["default"].info
    }, "No data for selected ", labelForDeployment || 'Data Collection Wave', "s"));
  }();
  if (renders.renderLayout) {
    return renders.renderLayout({
      table: table,
      queryDropdown: queryDropdown,
      visualizeButton: visualizeButton,
      customizeButton: customizeButton,
      saveButton: saveButton
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showHeader && /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    assignmentIdWhitelist: assignmentIdWhitelist,
    customSwitchProject: customSwitchProject,
    deploymentIdWhitelist: deploymentIdWhitelist,
    isExported: isExported,
    labelForDeployment: labelForDeployment,
    labelForProject: labelForProject,
    labelForProjectPlural: labelForProjectPlural,
    labelForQuest: labelForQuest,
    labelForSurvey: labelForSurvey,
    projectIdWhitelist: projectIdWhitelist,
    limitProjectsByPermissions: _questPermissionsByArea["default"].data.permissions,
    showProjectDropdown: !hideProjectDropdown,
    showQuestCount: false,
    rightSection: getRightSection()
  }), table);
};
Data.propTypes = {
  assignmentId: _propTypes["default"].number,
  assignmentIdWhitelist: _propTypes["default"].array,
  customSwitchProject: _propTypes["default"].func,
  deploymentIdWhitelist: _propTypes["default"].array,
  deploymentIds: _propTypes["default"].array,
  deployments: _propTypes["default"].array,
  hideDeploymentDropdown: _propTypes["default"].bool,
  hideProjectDropdown: _propTypes["default"].bool,
  hideQuestDropdown: _propTypes["default"].bool,
  hideSystemId: _propTypes["default"].bool,
  isExported: _propTypes["default"].bool,
  labelForDeployment: _propTypes["default"].string,
  labelForProject: _propTypes["default"].string,
  labelForProjectPlural: _propTypes["default"].string,
  labelForQuest: _propTypes["default"].string,
  labelForSurvey: _propTypes["default"].string,
  project: _propTypes["default"].object,
  projectAssignments: _propTypes["default"].array,
  projectIdWhitelist: _propTypes["default"].array,
  projectQueries: _propTypes["default"].array,
  currentQueryId: _propTypes["default"].string,
  currentQuerySettings: _propTypes["default"].object,
  showCustomizeButton: _propTypes["default"].bool,
  showVisualizeButton: _propTypes["default"].bool,
  showSaveButton: _propTypes["default"].bool,
  showQueriesWithTags: _propTypes["default"].array,
  constantFilter: _propTypes["default"].object,
  overrideInitialVisualizeSettings: _propTypes["default"].object,
  overrideVisualizeDeploymentLabels: _propTypes["default"].object,
  applyPawnContext: _propTypes["default"].bool,
  adjustColumns: _propTypes["default"].func,
  match: _propTypes["default"].object,
  // functions to render Data tab differently
  renders: _propTypes["default"].shape({
    // ({ table, queryDropdown, visualizeButton, customizeButton, saveButton }) => {}
    renderLayout: _propTypes["default"].func,
    // ({ open, disabled, disabledReason }) => {}
    renderVisualizeButton: _propTypes["default"].func,
    // ({ open }) => {}
    renderCustomizeButton: _propTypes["default"].func
  }),
  saveQueryInUrl: _propTypes["default"].bool,
  showVisualizeSettings: _propTypes["default"].bool
};
Data.defaultProps = {
  showCustomizeButton: true,
  showVisualizeButton: true,
  showSaveButton: true,
  renders: {},
  saveQueryInUrl: true
};
var mapStateToProps = function mapStateToProps(state) {
  var _state$assignment$adm;
  var _getPopulatedCurrentQ = (0, _admin.getPopulatedCurrentQuerySettings)(state.assignment.admin),
    deployments = _getPopulatedCurrentQ.deployments,
    deploymentIds = _getPopulatedCurrentQ.deploymentIds;
  return {
    project: (0, _admin.getCurrentProject)(state.assignment.admin),
    assignmentId: state.assignment.admin.currentQuerySettings.assignmentId,
    deployments: deployments,
    deploymentIds: deploymentIds,
    projectQueries: (0, _admin.getCurrentProjectQueries)(state.assignment.admin),
    hasQueryTagFilter: Boolean(((_state$assignment$adm = state.assignment.admin.queryTagFilter) === null || _state$assignment$adm === void 0 ? void 0 : _state$assignment$adm.length) > 0),
    currentQueryId: state.assignment.admin.currentQueryId,
    currentQuerySettings: state.assignment.admin.currentQuerySettings
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(Data); // **********************
function SaveQueryButton(_ref6) {
  var showSaveButton = _ref6.showSaveButton,
    project = _ref6.project,
    currentQueryId = _ref6.currentQueryId,
    tooltipRef = _ref6.tooltipRef,
    dispatch = _ref6.dispatch,
    currentQuerySettings = _ref6.currentQuerySettings,
    hasChanges = _ref6.hasChanges;
  if (!showSaveButton || !Fortress.hasAccess('quest.tables_edit', project === null || project === void 0 ? void 0 : project.groupId)) {
    return null;
  }
  if (currentQueryId && currentQueryId !== '0') {
    return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: '0.5rem'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-secondary",
        style: {
          width: '100%'
        },
        onClick: function onClick() {
          dispatch((0, _admin2.updateQuery)({
            id: currentQueryId,
            settings: currentQuerySettings
          }));
          tooltipRef.current && tooltipRef.current.hide();
        }
      }, "Update query")), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        renderTrigger: function renderTrigger(_ref7) {
          var _onClick = _ref7.onClick;
          return /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-secondary",
            onClick: function onClick() {
              _onClick();
              tooltipRef.current && tooltipRef.current.hide();
            }
          }, "Save as New query");
        },
        title: "Choose query name"
      }, /*#__PURE__*/_react["default"].createElement(_QueryNameForm["default"], {
        onSubmit: function onSubmit(values) {
          dispatch((0, _admin2.addNewQuery)({
            name: values.name,
            settings: currentQuerySettings
          }));
        }
      })))),
      tippyProps: {
        trigger: 'click',
        placement: 'bottom-end',
        arrow: false,
        interactive: true,
        theme: 'light',
        offset: [0, 5],
        onShow: function onShow(instance) {
          tooltipRef.current = instance;
        }
      }
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: hasChanges ? 'btn btn-warning' : 'btn btn-secondary',
      style: {
        marginLeft: '1rem'
      }
    }, "Save"));
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: hasChanges ? 'btn btn-warning' : 'btn btn-secondary',
      style: {
        marginLeft: '1rem'
      }
    }, "Save"),
    title: "Choose query name"
  }, /*#__PURE__*/_react["default"].createElement(_QueryNameForm["default"], {
    onSubmit: function onSubmit(values) {
      dispatch((0, _admin2.addNewQuery)({
        name: values.name,
        settings: currentQuerySettings
      }));
    }
  }));
}